import { BrowserRouter } from 'react-router-dom';
import { Box } from '@mui/material';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { ScrollRestoration } from './router';
import { AppRouter } from './router/AppRouter';

function App() {
  return (
    <BrowserRouter>
      <ScrollRestoration />
      <Box
        component="a"
        href="#main-content"
        sx={{
          position: 'absolute',
          left: '-9999px',
          '&:focus': {
            position: 'fixed',
            top: 10,
            left: 10,
            zIndex: 9999,
            width: 'auto',
            height: 'auto',
            p: '8px 16px',
            bgcolor: 'background.paper',
            border: 2,
            borderColor: 'text.primary',
            borderRadius: 1,
            textDecoration: 'none',
            color: 'text.primary',
          },
        }}
      >
        Skip to main content
      </Box>
      <Header />
      <main id="main-content">
        <AppRouter />
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
